import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import { withDefaults } from 'vue';
import FilterIcon from './icons/FilterIcon.vue';

interface IProps {
  title: string;
  classes?: string[];
  noMargin?: boolean;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: string;
  noDivider?: boolean;
  useGradient?: boolean;
  filter?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomTitle',
  props: {
    title: {},
    classes: {},
    noMargin: { type: Boolean },
    fontSize: {},
    fontWeight: {},
    lineHeight: {},
    noDivider: { type: Boolean },
    useGradient: { type: Boolean },
    filter: { type: Boolean }
  },
  emits: ['openModal'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function handleFilter() {
  emit('openModal');
}


return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, {
      align: "center",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", {
          style: _normalizeStyle({ marginBottom: _ctx.noMargin ? 0 : '16px', fontSize: _ctx.fontSize ? _ctx.fontSize : '', lineHeight: _ctx.lineHeight ? _ctx.lineHeight : '', fontWeight: _ctx.fontWeight ? _ctx.fontWeight : '' }),
          class: _normalizeClass([_ctx.classes, _ctx.useGradient ? 'label-text' : ''])
        }, _toDisplayString(props.title), 7),
        (_ctx.filter)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "filter-text",
              onClick: handleFilter
            }, [
              _createVNode(FilterIcon, { class: "mr-1" }),
              _createTextVNode(" Filtros ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.noDivider)
      ? (_openBlock(), _createBlock(_component_v_divider, {
          key: 0,
          class: "mt-2 mb-4 color-divider"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})